import { CSSProperties } from 'react'

export const s = {
  card: {
    padding: 0,
  },
  expand: {
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  content: {
    padding: 24,
  },
}
